import React, { useContext } from 'react';
import { createContext } from 'react';

import { User } from '@utils/backend-api/currentUser';

export enum RailsEnv {
  Test = 'test',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}
/* eslint-disable  @typescript-eslint/no-explicit-any */
// If you modify this list make sure to maintain parity with the server side
// env helper: `app/helpers/application_helper.rb`
export interface Env {
  BLUECONIC_CONTENT_COLLECTOR_ID?: string;
  GOOGLE_CLIENT_ID?: string;
  IMGIX_ENV?: string;
  IMGIX_URL?: string;
  READ_ONLY_MODE?: string;
  READ_ONLY_PHRASE?: string;
  READER_URL?: string;
  RAILS_ENV?: RailsEnv;
  RECAPTCHA_SITE_KEY?: string;
  SHOW_MODAL_ON_INACTION_SECONDS?: string;
  SUBSCRIPTIONS_URL?: string;
  STRIPE_PUBLISH_KEY?: string;
}

export type Offers = {
  subscribe?: string;
  upgrade?: string;
};

export type AppContextType = {
  env: Env;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isWebview: boolean;
  offers?: Offers;
};

const AppContext = createContext<AppContextType>({
  env: {},
  isGdprRequired: false,
  isWebview: false,
  offers: undefined,
});

export const AppContextProvider = ({
  children,
  env,
  initialCurrentUser,
  isGdprRequired = false,
  isWebview = false,
  offers,
}: {
  children: React.ReactNode;
  env?: Env;
  initialCurrentUser?: User;
  isGdprRequired?: boolean;
  isWebview?: boolean;
  offers?: Offers;
}) => {
  const value = {
    env,
    initialCurrentUser,
    isGdprRequired,
    isWebview,
    offers,
  };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  return context;
};
